import React, { useEffect, useState } from 'react';
import { ToggleButton, ToggleSlider } from "./style";

interface RoundedToggleButtonProps {
    onToggle?: (isOn: boolean) => void;
    defaultValue?: boolean;
}

const RoundedToggleButton: React.FC<RoundedToggleButtonProps> = ({ onToggle, defaultValue = false }) => {
    const [isOn, setIsOn] = useState<boolean>(defaultValue);

    useEffect(() => {
        setIsOn(defaultValue);
    }, [defaultValue])

    const handleToggle = () => {
        setIsOn(prevState => {
            const newState = !prevState;
            if (onToggle) {
                onToggle(newState);
            }
            return newState;
        });
    };

    return (
        <ToggleButton isOn={isOn} onClick={handleToggle}>
            <ToggleSlider isOn={isOn} />
        </ToggleButton>
    );
};

export default RoundedToggleButton;
